import * as XLSX from 'xlsx';
import { MAX_EMPTY_STREAK } from '../constants/constants';

export const parseColumnsFromSheet = (sheet) => {
  const range = XLSX.utils.decode_range(sheet['!ref']);
  const validColumns = [];

  for (let colIndex = range.s.c; colIndex <= range.e.c; colIndex++) {
    const colLetter = XLSX.utils.encode_col(colIndex);
    let isColumnEmpty = true;

    for (let rowIndex = range.s.r; rowIndex <= range.e.r; rowIndex++) {
      const cell = sheet[`${colLetter}${rowIndex + 1}`];
      if (cell?.v) {
        isColumnEmpty = false;
        break;
      }
    }

    if (isColumnEmpty) break;
    validColumns.push(colLetter);
  }

  return validColumns;
};

export const parseRowsWithData = (sheet, validColumns) => {
  const range = XLSX.utils.decode_range(sheet['!ref']);
  const rowsWithData = [];
  let emptyRowStreak = 0;

  for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
    const hasData = validColumns.some((col) => {
      const cell = sheet[`${col}${rowNum + 1}`];
      return cell?.v;
    });

    if (hasData) {
      emptyRowStreak = 0;
      rowsWithData.push(rowNum + 1);
    } else {
      emptyRowStreak++;
      if (emptyRowStreak >= MAX_EMPTY_STREAK) break;
    }
  }

  return rowsWithData;
};

export const formatExcelDate = (excelDate) => {
  if (typeof excelDate !== 'number') return excelDate;
  const date = XLSX.SSF.parse_date_code(excelDate);
  if (!date) return excelDate;
  return `${String(date.d).padStart(2, '0')}.${String(date.m).padStart(
    2,
    '0'
  )}.${date.y}`;
};
